import { render, staticRenderFns } from "./AirTicketBooking.vue?vue&type=template&id=be0ff880&scoped=true"
import script from "../../assets/ts/tripinfo/AirTicketBooking.ts?vue&type=script&lang=ts&external"
export * from "../../assets/ts/tripinfo/AirTicketBooking.ts?vue&type=script&lang=ts&external"
import style0 from "./AirTicketBooking.vue?vue&type=style&index=0&id=be0ff880&prod&lang=sass&scoped=true"
import style1 from "./AirTicketBooking.vue?vue&type=style&index=1&id=be0ff880&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be0ff880",
  null
  
)

export default component.exports